import { render, staticRenderFns } from "./ReservationRevisions.vue?vue&type=template&id=59f37e08"
import script from "./ReservationRevisions.vue?vue&type=script&lang=js"
export * from "./ReservationRevisions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports